import { ReactNode } from "react";

import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app/app-sidebar";
import { Footer } from "@/components/app/footer";
import { Header } from "@/components/app/header";

interface MainLayoutProps {
  children: ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  return (
    <SidebarProvider className="min-h-screen" defaultOpen={false}>
      <AppSidebar className="h-auto min-h-0" />

      <SidebarInset className="w-full">
        <Header />
        <div className="flex min-h-0 flex-1 px-14 pb-10 pt-24 md:px-10">
          {children}
        </div>
        <Footer />
      </SidebarInset>
    </SidebarProvider>
  );
}
